import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "next-draws-filter" }
const _hoisted_2 = { class: "date-selector" }
const _hoisted_3 = ["value", "min"]




const __default__ = {
  name: 'NextDrawsFilter'
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    modelValue: { default: () => new Date().toISOString().split('T')[0] },
    allowPast: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const today = new Date().toISOString().split('T')[0];

const emit = __emit;

const handleInput = (event: Event) => {
  const target = event.target as HTMLInputElement;
  emit('update:modelValue', target.value || today);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("input", {
        type: "date",
        value: _ctx.modelValue,
        min: _ctx.allowPast ? null : _unref(today),
        onChange: handleInput,
        class: "date-input"
      }, null, 40, _hoisted_3)
    ])
  ]))
}
}

})